const REACT_APP = /^REACT_APP_/i;

export const isProduction = process.env.NODE_ENV === 'production'
export const useCounters = process.env.NODE_ENV === 'production'

const env = Object.keys(process.env)
  .filter(key => REACT_APP.test(key))
  .reduce(
    (env, key) => {
      env[key] = process.env[key];
      return env;
    },
    {
      isProduction,
      useCounters
    }
  );

export default env;
